import Vue from 'vue';
import VueTimers from 'vue-timers';
import AudioPlayer from '@/plugins/AudioPlayer';
import App from './App';
import router from './router';
import store from './store';
import auth from './auth';
import RestClient from './api/RestClient';
import extensions from './extensions';
import modules from './modules';

Vue.config.productionTip = false;
Vue.use(VueTimers);
Vue.use(AudioPlayer);

// When the server says the session is gone, forget it and go to sign-in if the page needs it.
RestClient.onNotSignedIn = () => {
  auth.forget();
  const r = router.currentRoute;
  if (r.meta.auth) router.push({ name: 'signin', query: { next: r.fullPath } });
};

// The player's settings (SPEC §4.6), kept in this browser, apply from the first page shown.
try {
  const ui = JSON.parse(localStorage.getItem('ui'));
  if (ui) store.commit('set', { ui });
} catch (e) {
  localStorage.removeItem('ui');
}

// Modules register their routes and extensions before the first page is shown.
Promise.all([auth.load(), ...modules.map(m => m.init({ router, extensions }))]).then(() => {
  new Vue({
    render: h => h(App),
    router,
    store
  }).$mount('#app');
});
